import React, { useState, useEffect } from 'react';
import withoutAuth from '../../hocs/withoutAuth';
import { Box, Button, Text, InputPassword, InputText } from 'condolivre-ds';
import Layout from '../../components/Layout/Layout';
import { Container, Row, Col } from 'react-grid-system';
import styles from './index.module.scss';
import { useAuth } from '@/providers/Auth';
import Image from 'next/image';
import { formModel, validateModel } from './model';
import { requestForgotPassword } from './network';
import { authenticate } from './helpers';

// TODO: Return Pre Register Button after develop the page

export default withoutAuth(function Login() {
    const [responseStatus, setResponseStatus] = useState('');
    const [responseMsg, setResponseMsg] = useState('');
    const [responseEmail, setResponseEmail] = useState('');
    const [form, setForm] = useState(formModel);
    const [validateRules, setValidateRules] = useState(validateModel);
    const [validateReady, setValidateReady] = useState(false);
    const [validateForgotReady, setValidateForgotReady] = useState(false);
    const { setAuthenticated } = useAuth();

    const status = {
        success: 'success',
        error: 'error',
        reset: 'reset'
    };

    useEffect(() => {
        if (validateReady) {
            validate();
        }
        if (validateForgotReady) {
            validateForgot();
        }
    }, [form]);

    useEffect(() => {
        setResponseEmail(responseEmail.replace(responseEmail.substring(4, 11), '*******'));
    }, [responseEmail]);

    const validate = () => {
        setValidateReady(true);
        setValidateRules({
            email: form.email ? '' : 'Campo obrigatório',
            password: form.password ? '' : 'Campo obrigatório'
        });
    };

    const validateForgot = () => {
        setValidateForgotReady(true);
        setValidateRules({
            email: form.email ? '' : 'É necessário preencher um e-mail.',
            password: ''
        });
    };

    const handleInput = (field) => (e) => {
        setForm({
            ...form,
            [field]: e.target.value
        });
    };

    const handleSubmit = (email, password) => {
        authenticate(email, password, setAuthenticated, setResponseStatus, setResponseMsg);
    };

    const handleSubmitReset = (email) => {
        requestForgotPassword(email).then((response) => {
            if (response.success) {
                setResponseStatus(status.reset);
                setResponseEmail(response.email);
            } else {
                setResponseStatus(status.error);
                setResponseMsg(response.msg);
            }
        });
    };

    const onSubmit = () => {
        validate();

        setValidateRules((state) => {
            if (!state.email && !state.password) {
                handleSubmit(form.email, form.password);
            }

            return state;
        });
    };

    const onSubmitForgot = () => {
        validateForgot();

        setValidateRules((state) => {
            if (!state.email) {
                handleSubmitReset(form.email);
            }

            return state;
        });
    };

    const backToLogin = () => {
        setResponseStatus('');
    };

    return (
        <Layout>
            <Container className={styles.container}>
                <Row>
                    <Col md={6} xl={7} className={styles.welcome}>
                        <div className={styles.box}>
                            <Image src="/images/Logo_condolivre_neg.png" width={120} height={31} />

                            <Text color="white" weight="v_300" size="v_30" className={styles.label}>
                                Portal das Administradoras
                            </Text>
                            <Text color="white" weight="v_300" size="v_24" className={styles.text}>
                                Gerenciamento de diversas funcionalidades em uma única plataforma.
                            </Text>

                            {/*<Text color="white" weight="v_300" size="v_16" className={styles.text}>*/}
                            {/*    Ainda não utiliza a plataforma?*/}
                            {/*</Text>*/}
                            {/*<Button size="small" variant="primary" onClick={onPreRegisterUrl}>*/}
                            {/*    Faça seu pré-cadastro*/}
                            {/*</Button>*/}
                        </div>
                        <div className={styles.img}>
                            <Image src="/images/img-adm.png" width="400" height="571" />
                        </div>
                    </Col>
                    <Col md={6} xl={5}>
                        {responseStatus === '' && (
                            <Box className={styles.boxLogin}>
                                <Text color="black" weight="v_500" size="v_26">
                                    Seja bem-vindo!
                                </Text>
                                <Text
                                    color="gray_700"
                                    family="regular"
                                    weight="v_500"
                                    size="v_16"
                                    className={styles.sub}>
                                    Insira seus dados para acessar a plataforma
                                </Text>
                                <InputText
                                    name="email"
                                    id="email"
                                    onChange={handleInput('email')}
                                    error={validateRules.email.length > 0}
                                    errorMessage={validateRules.email}
                                    label="E-mail"
                                />

                                <InputPassword
                                    name="password"
                                    id="password"
                                    onChange={handleInput('password')}
                                    error={validateRules.password.length > 0}
                                    errorMessage={validateRules.password}
                                    label="Senha"
                                />

                                <div className={styles.containerForgot}>
                                    <button className={styles.forgot} onClick={onSubmitForgot}>
                                        Esqueci minha senha
                                    </button>
                                </div>

                                <Button variant="primary" onClick={onSubmit}>
                                    Acessar a plataforma
                                </Button>
                            </Box>
                        )}

                        {responseStatus === status.error && (
                            <Box className={[styles.boxLogin, styles.success].join(' ')}>
                                <Image
                                    src="/images/emoji_md_attention.svg"
                                    width={60}
                                    height={60}
                                />

                                <Text family="medium" weight="bold" size="v_22" color="gray_700">
                                    {responseMsg
                                        ? responseMsg
                                        : ' Houve um erro em sua solicitação'}
                                </Text>
                                <Button variant="primary" onClick={backToLogin}>
                                    Voltar ao início
                                </Button>
                            </Box>
                        )}

                        {responseStatus === status.reset && (
                            <Box className={[styles.boxLogin, styles.success].join(' ')}>
                                <Image
                                    src="/images/emoji_md_attention.svg"
                                    width={60}
                                    height={60}
                                />

                                <Text weight="bold" size="v_22" color="gray_700">
                                    Esqueceu sua senha?
                                </Text>
                                <Text weight="700" size="v_18" color="gray_700">
                                    Enviamos um link para redefinição de senha para o seu email:
                                    <br />
                                </Text>

                                <Text weight="bold" size="v_18" color="black">
                                    {responseEmail}
                                    <br />
                                    <br />
                                    <br />
                                </Text>

                                <Button variant="primary" onClick={backToLogin}>
                                    Voltar ao início
                                </Button>
                            </Box>
                        )}
                    </Col>
                </Row>
            </Container>
        </Layout>
    );
});
